module.exports = __webpack_public_path__ + "static/media/catalog-un.bf720ea6.svg";